//Import required modules
import * as d3 from 'd3';
import { v4 } from 'uuid'
import { isMobile } from 'react-device-detect';

export const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result 
    ? 
    `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`
    : 
    null;
  }

export const checkColorType = (val) => val[0] === '#'?'hex':'rgb'

export const makeColorArray = (colorFunc, userWindow) =>
{
let circleCount = userWindow.circleCount
let arr = d3.range(circleCount)
let rowHeight = userWindow.rowHeight;
let width = userWindow.rowWidth;
let radius = userWindow.radius;
let myColor = d3.scaleSequential()
                // .domain([d3.min(arr), d3.max(arr)])
                .domain([d3.max(arr), d3.min(arr)])
                .interpolator(colorFunc.colorFuncName)
let x = d3.scaleBand()
          .domain(arr)                
          .range([0, width])
          .padding(0.0)
let bandwidth = x.bandwidth()/2          
let colorArr = d3.range(circleCount).map((d, i) =>
                ({
                    "cx": x(d)+bandwidth,
                    "cy": (0.85*rowHeight)/2,
                    "radius": radius,
                    "color": checkColorType(myColor(d)) === 'hex'?hexToRgb(myColor(d)):myColor(d),
                    "selected": false,
                    "id": v4()
                }))
let colorArrObj = {colorFuncName: colorFunc.colorFuncName,
                    colorRowId: v4(),
                    colorArr: colorArr,
                    selectAll: false
                }            
return colorArrObj                
}


//Supporting Reducers
export const componentToHex = (c) => (c.toString(16)).length === 1? '0' + c.toString(16) : c.toString(16);
export const rgbToHex = ({r,g,b}) =>  "#" + componentToHex(r) + componentToHex(g) + componentToHex(b)
export const extractHexVal = (rgbString) => {
    let string = rgbString.replace(/[()rgb,]/g, '') //replace text rgb & parenthesis to no char
    string = string.replace(/ /g, '_') //replace space with underscore to use as delimiter
    let values = string.split('_')
    let dict = {"r": parseInt(values[0]),
                "g": parseInt(values[1]),
                "b": parseInt(values[2])}
    let hexVal = rgbToHex(dict)
    hexVal = hexVal.toUpperCase()
    return hexVal
}
export const extractHexValHashless = (rgbString) => {
    let string = rgbString.replace(/[()rgb,]/g, '') //replace text rgb & parenthesis to no char
    string = string.replace(/ /g, '_') //replace space with underscore to use as delimiter
    let values = string.split('_')
    let dict = {"r": parseInt(values[0]),
                "g": parseInt(values[1]),
                "b": parseInt(values[2])}
    let hexVal = rgbToHex(dict)
    hexVal = hexVal.replace(/#/g, '')
    return hexVal
}


export const makeUserRow = (userColorArr, userWindow) =>
{
let circleCount = userWindow.circleCount
let width = userWindow.rowWidth
let height = userWindow.rowHeight-10
let radius = userWindow.radius
let arr = d3.range(circleCount) 
let x = d3.scaleBand()
          .domain(arr)                
          .range([0, width])
          .padding(0.0)
let bandwidth = x.bandwidth()/2          
let colorArr = userColorArr.map((d, i) =>
                ({
                    "cx": x(i)+bandwidth,
                    "cy": height/2,
                    "radius": radius,
                    "color": userColorArr[i].color,
                    "id": userColorArr[i].id,
                    "selected": userColorArr[i].selected
                }))
return colorArr 
}

export const makeUserPalette = (userPalette, userWindow) =>
{
    let circleCount = userWindow.circleCount
    let len = userPalette.length
    if(len === 0){
        return []
    }
    else{
        
        let subArrCnt = Math.ceil(len/circleCount)
        let userArr = d3.range(subArrCnt).map((d) => makeUserRow([...userPalette].slice(d*circleCount,(d*circleCount)+circleCount), userWindow))
        return userArr
    }
}

export const makeColorArrayNew = (startHex, endHex, userWindow) =>
{
let circleCount = userWindow.circleCount
let width = userWindow.rowWidth
let rowHeight = userWindow.rowHeight
let colorSpace = userWindow.colorSpace
let radius = userWindow.radius  
let fontSize = userWindow.fontSize
let textSpace = userWindow.textSpace

let arr = d3.range(circleCount) 
let myColor = d3.scaleSequential()
                .domain([d3.min(arr), d3.max(arr)])
                .interpolator(d3.interpolate(startHex, endHex))
let x = d3.scaleBand()
          .domain(arr)                
          .range([0, width])
          .padding(0.0)
let bandwidth = x.bandwidth()/2          
let colorArr = d3.range(circleCount).map((d, i) =>
                ({
                    "cx": x(d)+bandwidth,
                    "cy": (colorSpace*rowHeight)/2,
                    "radius": radius,
                    "color": myColor(d),
                    "selected": false,
                    "id": v4()
                }))
let colorArrObj = {colorFuncName: d3.interpolate(startHex, endHex),
                    colorRowId: v4(),
                    colorArr: colorArr,
                    selectAll: false}            
return colorArrObj                
}

export const updateColorArr = (colorArr, userWindow) => 
{
let circleCount = userWindow.circleCount
let rowWidth = userWindow.rowWidth
let rowHeight = userWindow.rowHeight
let radius = userWindow.radius
let colorSpace = userWindow.colorSpace
let arr = d3.range(circleCount)
let x = d3.scaleBand()
          .domain(arr)                
          .range([0, rowWidth])
          .padding(0.0)
let bandwidth = x.bandwidth()/2
let colorArrNew = colorArr.map((colorObj) => 
                ({
                    ...colorObj,
                    colorArr: colorObj.colorArr.map((color, index) =>
                    ({
                        ...color,
                        cx: x(index)+bandwidth,
                        cy: (colorSpace*rowHeight)/2,
                        radius
                    })
                    )
                })
            )          
return colorArrNew
}


export const copyTextToClipboard = (colorClicked) =>
{

    /* Get the text field */
    let copyText = document.getElementById("colorClicked");

    /* Setting the value of the element to the string passed */
    copyText.value = extractHexVal(colorClicked)
    // console.log(copyText.value)
    
    /* Select the text field */
    if(isMobile){
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    }
    else{
        copyText.select();
    }
    
    /* Copy the text inside the text field */
    document.execCommand("copy");

    // let colorClipDiv = document.getElementById('colorClipDiv')
    // colorClipDiv.classList.remove("invisible");
    // colorClipDiv.classList.add("visible");
    // colorClipDiv.classList.remove("visible");
    // colorClipDiv.classList.add("invisible");

    // let tooltip = document.getElementById("myTooltip");
    // tooltip.innerHTML = "Copied: " + extractHexVal(colorClicked)
    
    /* Alert the copied text */
    // alert("Copied the text: " + copyText.value);
    
}



export const downloadCsv = (userPalette) => 
{

    console.log(userPalette)
    userPalette = userPalette.flat().map((d) => ({"color": d.color}))
    console.log(userPalette)

    let csvString = `"colorRgb","colorHex"\n`
    userPalette.map(d => csvString = csvString + `"${d.color}","${extractHexValHashless(d.color)}"\n`)
    console.log(csvString)
    let csvContent = `data:text/csv;charset=utf-8,${csvString}`

    let dataUriCsv = encodeURI(csvContent)
    let exportFileDefaultNameCsv = 'myPalette.csv';
    let linkElementCsv = document.createElement('a');
    linkElementCsv.setAttribute('href', dataUriCsv);
    linkElementCsv.setAttribute('download', exportFileDefaultNameCsv);
    linkElementCsv.click();
}

export const downloadJson = (userPalette) => 
{

    userPalette = userPalette.flat().map(d => ({"colorRgb": d.color,
                                                    "colorHex": extractHexVal(d.color)}))

    let dataStr = JSON.stringify(userPalette);
    let dataUriJson = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    let exportFileDefaultNameJson = 'myPalette.json';
    let linkElementJson = document.createElement('a');
    linkElementJson.setAttribute('href', dataUriJson);
    linkElementJson.setAttribute('download', exportFileDefaultNameJson);
    linkElementJson.click();
}

export const downloadArr = (userPalette) => 
{

    userPalette = userPalette.flat().map(d => extractHexVal(d.color))

    let dataStr = JSON.stringify({userPalette});
    let dataUriJson = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    let exportFileDefaultNameJson = 'myPalette.json';
    let linkElementJson = document.createElement('a');
    linkElementJson.setAttribute('href', dataUriJson);
    linkElementJson.setAttribute('download', exportFileDefaultNameJson);
    linkElementJson.click();
}

export  const downloadJpeg = (userPalette, userWindow, theme) => 
{

    let colorArr = userPalette.flat().map(d => ({"colorRgb": d.color,
                                                    "colorHex": extractHexVal(d.color)}))
    let colorArrLen = colorArr.length

    let rectColor = theme === 'dark'? "#212121":"#F7F7F7";
    let fontColor = theme === 'dark'? "#F7F7F7":"#212121";

    // let 

    //DAILY VIEW TREND CHART
    let margin = {top: 25, right: 20, bottom: 25, left: 20},
    width = 500 - margin.left - margin.right,
    height = (colorArrLen*50) - margin.top - margin.bottom,
    widthWhole = width+margin.left+margin.right,
    heightWhole = height+margin.top+margin.bottom,
    widthPalette = (0.75)*width,
    widthCodes = (0.25)*width;

    // Add Y axis
    var y = d3.scaleBand()
                .domain(d3.range(colorArrLen))
                .range([0, height])
                .paddingInner(0.4);
    
    //select div which has the svg and get inner html
    let svg = d3.select("body")
                .append('div')
                    .attr('id', 'myPaletteDiv')
                    .attr('left', '-9999px')
                    .attr('position', 'fixed')
                    .attr('z-index', '-100')
                    .attr('opacity', 0)
                .append('svg')
                    .attr('id', 'myPaletteSvg')
                    .attr("version", 1.1)
                    .attr("xmlns", "http://www.w3.org/2000/svg")
                    .attr('width', widthWhole)
                    .attr('height', heightWhole)
    
    //Adding rectangle as per the theme
    svg.append('rect')
        .attr('width', widthWhole)
        .attr('height', heightWhole)                        
        .attr('x', 0)
        .attr('y', 0)
        .attr('fill', rectColor)

    svg.append('g')
            .attr("transform", `translate(${margin.left},${margin.top})`)
        .selectAll("rect")
        .data(d3.range(colorArrLen))
        .enter()
        .append('rect')
            .attr("x", 0)
            .attr("y", d => y(d))
            .attr("width", widthPalette)
            .attr('height', y.bandwidth())
            .attr('fill', (d,i) => colorArr[i].colorHex)
            // .attr('opacity', d => d*0.05)

    svg.append('g')
            .attr("transform", `translate(${margin.left+widthPalette+(widthCodes/2)+10},${margin.top})`)
        .selectAll("text")
        .data(d3.range(colorArrLen))
        .enter()
        .append('text')
            .attr("x", 0)
            .attr("y", d => y(d)+(y.bandwidth()/2)+7)
            .attr('text-anchor', 'middle')
            .attr('font-family', 'Monospace')
            .attr('font-size', '15px')
            .attr('fill', fontColor)
            .text((d,i) => colorArr[i].colorHex)

    let html = svg.node().parentNode.innerHTML;
    console.log(html)
    //make canvas element and get context
    let canvas = document.createElement("canvas");
    //setting id
    canvas.id = 'myPaletteCanvas'
    //set canvas height and width
    canvas.width = widthWhole;
    canvas.height = heightWhole;
    console.log(canvas)
    let context = canvas.getContext("2d");
    
    //make an image object
    var imgsrc = 'data:image/svg+xml;base64,'+ btoa(html);
    var image = new Image;
    image.src = imgsrc;
    console.log(imgsrc)
    
    // when the image loads, paint the svg onto the canvas and download as png
    image.onload = function() {
        
        context.drawImage(image, 0, 0);
    
        var a = document.createElement("a");
        a.download = "myPalette.png";
        a.href = canvas.toDataURL("image/png");
        a.click();
    
        // Remove Canvas element
        let canvasObj = document.getElementById("myPaletteDiv");
        canvasObj.remove();
    };
}


export const downloadViz = (userWindow, theme, chartSelected, imgFormat) => 
{
    chartSelected = chartSelected.toUpperCase()
    console.log(imgFormat)
    let svgViz = document.getElementById(`myViz${chartSelected}`)
    console.log(svgViz)
    console.log(svgViz.style)
    console.log(svgViz.innerHTML)
    let widthWhole = svgViz.getAttribute("width")
    let heightWhole = svgViz.getAttribute("height")
    console.log(widthWhole)
    console.log(heightWhole)

    let rectColor = theme === 'dark'? "#212121":"#F7F7F7";

    //select div which has the svg and get inner html
    let svg = d3.select("body")
                .append('div')
                    .attr('id', 'myVizDiv')
                    .attr('left', '-9999px')
                    .attr('position', 'fixed')
                    .attr('z-index', '-100')
                    .attr('opacity', 0)
                .append('svg')
                    .attr('id', 'myVizSvg')
                    .attr("version", 1.1)
                    .attr("xmlns", "http://www.w3.org/2000/svg")
                    .attr('width', widthWhole)
                    .attr('height', heightWhole)
    

    if(imgFormat === 'jpeg'){
    //Adding rectangle as per the theme
        svg.append('rect')
            .attr('width', widthWhole)
            .attr('height', heightWhole)                        
            .attr('x', 0)
            .attr('y', 0)
            .attr('fill', rectColor)
    }                    

    let svgHtml = document.getElementById('myVizDiv').innerHTML
    svgHtml = svgHtml.replace(/<\/svg>/g, '')
    console.log(svgHtml)
    let html = `${svgHtml}${svgViz.innerHTML}</svg>`
    console.log('')
    console.log(html) 
    // make canvas element and get context
    let canvas = document.createElement("canvas");
    //setting id
    canvas.id = 'myVizCanvas'
    //set canvas height and width
    canvas.width = widthWhole;
    canvas.height = heightWhole;
    console.log(canvas)
    let context = canvas.getContext("2d");
    
    //make an image object
    var imgsrc = 'data:image/svg+xml;base64,'+ btoa(html);
    var image = new Image;
    image.src = imgsrc;
    console.log(imgsrc)
    
    // when the image loads, paint the svg onto the canvas and download as png
    image.onload = function() {
        
        context.drawImage(image, 0, 0);
    
        var a = document.createElement("a");
        a.download = `myViz.${imgFormat}`;
        a.href = canvas.toDataURL(`image/${imgFormat}`);
        a.click();
    
        // Remove Canvas element
        let canvasObj = document.getElementById("myVizDiv");
        canvasObj.remove();
    };
}


console.log(extractHexVal('rgb(72, 96, 230)'))
